import { Component } from '@angular/core';
import { vendorLogin } from './vendor-login.model';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../shared/auth/auth-service';
import { StorageService } from '../shared/auth/storage-service';
import { LoginService } from '../shared/services/login-service';
import { VendorLoginService } from '../shared/services/vendor-login.service';
import { ConfigService } from '../services/config.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-vendor-login',
  templateUrl: './vendor-login.component.html',
  styleUrls: ['./vendor-login.component.scss']
})
export class VendorLoginComponent {
  login: vendorLogin = new vendorLogin();
  show_button: Boolean = false;
  show_eye: Boolean = false;
  constructor(
    private toastr: ToastrService,
    private vendorLogInServices: VendorLoginService,
    private router: Router,
    private authService: AuthService,
   private configService: ConfigService, 
    private http: HttpClient,
    private storageService: StorageService
  ) {
    if (this.authService.isLoggedIn()) {
      this.router.navigateByUrl('/vendor/dashboard')
    }
  }

  showPassword() {
    this.show_button = !this.show_button;
    this.show_eye = !this.show_eye;
  }

loginUser() {
  this.vendorLogInServices.userLogin(this.login).subscribe((res: any) => {
    if (res && res.body && res.status == 200) {
      const token = res.body.response.token;
      this.authService.setToken(token);
      this.authService.setAuthTokenInCookie(token);
      this.storageService.saveUser(res.body.response);
      this.toastr.success(res.body.message);
      
      // Approval gate removed: every vendor gets all modules and the dashboard
      this.fetchVendorModules();
      this.router.navigateByUrl('/vendor/dashboard');
    }
  }, (err: any) => {
    if (err.error && err.error.error) {
      this.toastr.error(err.error.error);
    } else {
      this.toastr.error(err.error.message);
    }
    console.error('Login error:', err);
  });
}

// ✅ Yeh method SIRF Approved vendors ke liye call hoga


// Method to fetch vendor modules using ConfigService
private fetchVendorModules() {
  const modulesUrl = this.configService.navigationVendorMastersUrl;
  
  this.http.get(modulesUrl).subscribe({
    next: (response: any) => {
      if (response && response.code === 200) {
        this.storageService.setVendorModules(response.data);
        console.log('✅ Vendor modules fetched successfully');
      }
    },
    error: (error) => {
      console.error('❌ Error fetching vendor modules:', error);
    }
  });
}
  loginAdmin() {
    this.router.navigateByUrl('/login')
  }
}
